"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const DropDownOption_1 = __importDefault(require("./DropDownOption"));
const prop_types_1 = __importDefault(require("prop-types"));
const Dropdown = ({ placeholder, options, callback, extra, className }) => {
    const [option, setOption] = react_1.useState({ label: placeholder, value: null });
    const [isDropdownOpen, setDropdownOpen] = react_1.useState(false);
    const onClickMenu = react_1.useCallback(() => {
        setDropdownOpen(!isDropdownOpen);
    }, [isDropdownOpen]);
    const onClickOption = react_1.useCallback(({ label, value, disabled }) => {
        if (disabled)
            return;
        setOption({ label, value });
        setDropdownOpen(false);
        if (callback) {
            callback({ label, value });
        }
    }, [callback]);
    return (react_1.default.createElement("div", { className: `${className} ecr-dropdown ${isDropdownOpen ? 'open' : ''}` },
        react_1.default.createElement("div", { className: "ecr-dropdown-menu ecr-dropdown-row", onClick: onClickMenu, role: "presentation" }, option.label),
        react_1.default.createElement("div", { className: "ecr-dropdown-list" },
            options.map(({ label, value, disabled, disableMark }, index) => (react_1.default.createElement(DropDownOption_1.default, { key: `option-${index}`, disabled: disabled, disableMark: disableMark, onClick: onClickOption, label: label, value: value }))),
            extra)));
};
Dropdown.propTypes = {
    placeholder: prop_types_1.default.string,
    options: prop_types_1.default.array,
    callback: prop_types_1.default.func,
    extra: prop_types_1.default.string
};
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map